import { useEffect } from 'react';

/**
 * Syncs a value to sessionStorage
 * If value is truthy, stores it; if falsy, removes the key.
 * This persists query params through Okta redirect flow.
 *
 * @param {string} key - The sessionStorage key
 * @param {string|null|undefined} value - The value to store
 */
export function useSyncSessionStorage(key, value) {
  useEffect(() => {
    if (value) {
      window.sessionStorage.setItem(key, value);
    } else {
      window.sessionStorage.removeItem(key);
    }
  }, [key, value]);
}

export default useSyncSessionStorage;
